const SALES_SOURCE_PARAM_KEYS = ['lvm_source', 'sales_source', 'salesSource'];

export const normalizeSalesSource = (value) => {
  if (typeof value !== 'string') return '';
  return value
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .replace(/[^a-z0-9._-]+/g, '_')
    .replace(/[.]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 64);
};

export const getSalesSourceFromUrl = (url) => {
  if (!url) return '';

  try {
    const parsedUrl = new URL(url, window.location.origin);
    for (const key of SALES_SOURCE_PARAM_KEYS) {
      const value = normalizeSalesSource(parsedUrl.searchParams.get(key) || '');
      if (value) return value;
    }
    return '';
  } catch (error) {
    return '';
  }
};

export const getSalesSourceFromLocation = () => {
  if (typeof window === 'undefined') return '';
  return getSalesSourceFromUrl(window.location.href);
};
